import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}externalCarrierDepositLabels/data`;
const FILE_FIELD_NAME = 'File';

interface UploadExternalCarrierDepositLabelCommandArgs {
  file: File;
}

async function uploadExternalCarrierDepositLabelCommand({
  file,
}: UploadExternalCarrierDepositLabelCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    const body = new FormData();

    body.append(FILE_FIELD_NAME, file);

    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      body,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default uploadExternalCarrierDepositLabelCommand;
